var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import Card from "@irati/ui/src/Layout/Card";
import { H1, H4 } from "@irati/ui/src/Typography";
import { FormattedMessage } from "@irati/utils/lang";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import sessionService from "@irati/auth/services/login";
import authentication from "@irati/auth";
import ActiveSession from "../../components/ActiveSession";
var Security = /** @class */ (function (_super) {
    __extends(Security, _super);
    function Security() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            sessions: []
        };
        return _this;
    }
    Security.prototype.componentDidMount = function () {
        var _this = this;
        this.sessionSub = sessionService.watchActive(authentication.user().uuid, { fetchPolicy: "network-only" }).subscribe(function (data) {
            var loginActiveSessions = data.data.loginActiveSessions;
            var sessions = _this.filterCurrentSessionToTop(loginActiveSessions);
            _this.setState({ sessions: sessions, load: null });
        });
    };
    Security.prototype.componentWillUnmount = function () {
        if (this.sessionSub) {
            this.sessionSub.unsubscribe();
        }
    };
    Security.prototype.filterCurrentSessionToTop = function (sessions) {
        var currentSession = sessions.filter(function (item) { return item.isCurrent; });
        var rest = sessions
            .filter(function (item) { return !item.isCurrent; })
            .sort(function (a, b) {
            return Date.parse(b.refreshedAt || b.createdAt) - Date.parse(a.refreshedAt || a.createdAt);
        });
        return __spreadArrays(currentSession, rest);
    };
    Security.prototype.render = function () {
        return (React.createElement(Card, { tiny: true, noBorder: true },
            React.createElement(H1, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "account.security.header" })),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(H4, { marginBottom: 4 },
                        React.createElement(FormattedMessage, { id: "account.security.sessions.header" })),
                    React.createElement(Loading, { load: this.state.load }, this.state.sessions.map(function (session) { return (React.createElement(ActiveSession, { key: session.uuid, session: session })); }))))));
    };
    return Security;
}(PureComponent));
export default Security;
